import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import * as components from '../../../components'
import {ChangeItem} from "./ChangeItem";
import {ChangeLogsProps} from "./types";


const ChangeLogs = ({ ticket }:ChangeLogsProps) => {
  return (
    <div className="mt-5">
      <ReactBootstrap.Card className="mt-5">
        <ReactBootstrap.Card.Title className="card-header bg-dark text-white card-header">
          Change Logs
        </ReactBootstrap.Card.Title>
        <ReactBootstrap.Card.Body className={'p-0'}>
          {ticket.change_logs.length ? (
            <components.ItemList
              itemRenderer={(index:number, key:string) => {
                return (
                  <ReactBootstrap.Col>
                    <div
                      className={
                        index % 2 === 0
                          ? 'bg-light pl-3 pt-3'
                          : 'bg-white pl-3 pt-3'
                      }
                      key={ticket.change_logs[index].url}
                    >
                      <ChangeItem
                        change={ticket.change_logs[index]}
                      />
                    </div>
                  </ReactBootstrap.Col>
                )
              }}
              length={ticket.change_logs.length}
            />
          ) : (
            <ReactBootstrap.Alert variant={'info'}>
              No previous change logs found.
            </ReactBootstrap.Alert>
          )}
        </ReactBootstrap.Card.Body>
      </ReactBootstrap.Card>
    </div>
  )
}

export default ChangeLogs
